import { render, staticRenderFns } from "./port-form.vue?vue&type=template&id=ab27f030"
import script from "./port-form.vue?vue&type=script&lang=js"
export * from "./port-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports